import { useEffect } from 'react';

import { commonStore, initRetailersAction } from 'stores';
import { useGetRequest } from 'hooks';

import { RetailersResponse } from 'codegen';

export const useCommonData = () => {
  const user = commonStore((state) => state.user);
  const isSessionExpired = commonStore((state) => state.isSessionExpired);
  const isRefetchCommonData = commonStore((state) => state.isRefetchCommonData);

  const { refresh } = useGetRequest<RetailersResponse>({
    url: '/merchants',
    options: {
      ready: !!user && !isSessionExpired,
      onSuccess: ({ data }) => initRetailersAction(data),
    },
  });

  useEffect(() => {
    if (isRefetchCommonData) {
      refresh();
    }
  }, [isRefetchCommonData]);
};
